var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-family":"Arial,微软雅黑,serif"},attrs:{"id":"app"}},[(this.$route.path !== '/')?_c('acn-head'):_vm._e(),_c('router-view'),(this.$route.path !== '/')?_c('acn-foot'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }